import type { DefaultDashboardDefinition } from './dashboard-definition';

export const homeDashboard: DefaultDashboardDefinition = {
  id: "home.main",
  appId: "home",
  name: "Home dashboard",
  record: null,
  queryScope: null,
  placements: [
    {
      id: "organisation.welcome.default",
      widgetId: "organisation.welcome",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "sales.revenue-trend.default",
      widgetId: "sales.revenue-trend",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 3,
      },
    },
    {
      id: "sales.order-count.default",
      widgetId: "sales.order-count",
      placement: {
        x: 0,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "sales.revenue.default",
      widgetId: "sales.revenue",
      placement: {
        x: 3,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "sales.sent-orders.default",
      widgetId: "sales.sent-orders",
      placement: {
        x: 6,
        y: 3,
        width: 3,
        height: 1,
      },
    },
    {
      id: "people.new-staff.default",
      widgetId: "people.new-staff",
      placement: {
        x: 9,
        y: 3,
        width: 3,
        height: 1,
      },
    },
  ],
};
